import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { Project } from '@app/models/project';
import { Observable } from 'rxjs';
import { ProjectService } from '@app/services/project.service';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-close-project-form',
  templateUrl: './close-project-form.component.html',
  styleUrls: ['./close-project-form.component.scss']
})
export class CloseProjectFormComponent implements OnInit {

  pdpProjectId = this.route.snapshot.params['pdpProjectId'];
  project$: Observable<Project>;
  project: Project;
  errorMessage: string;
  viewState = 'form';

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private changeDetectorRef: ChangeDetectorRef
    ) {  }

  ngOnInit() {

    this.project$ = this.projectService.getProject(this.pdpProjectId);
    this.project$.subscribe(p => {
      this.project = p;
      this.changeDetectorRef.detectChanges();
      return p;
    });

  }

  closeProject() {

    this.viewState = 'working';
    const req = this.projectService.closeProject(this.project);

    req.subscribe( result => {
      this.viewState = 'ready';
    },
    err => {
      console.log(err);
      this.errorMessage = err.message + ': ' + err.error;
      this.viewState = 'error';
      this.changeDetectorRef.detectChanges();
    });

  }

}
